import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, of, throwError } from 'rxjs';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialougeBox } from 'app/shared/dailog_box/custom_dialog';
import { AuthService } from 'app/core/auth/auth.service';
@Injectable({
    providedIn: 'root'
})
export class SetupService {
    public _header: BehaviorSubject<any> = new BehaviorSubject<any>({ parentTitle: null, title: null });
    private _baseURL: string = environment.apiOrigin + '/apiv1/';
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _snackBar: MatSnackBar, private _matDialog: MatDialog, private apiSrv: AuthService,
    ) {
        this._header.next({ title: null, parentTitle: null });
    }


    get(rte): Observable<any> {
        return this._httpClient.get(this._baseURL + rte);
    }
    post(rte, data): Observable<any> {
        return this._httpClient.post(this._baseURL + rte, { data: data });
    }
    put(rte, data): Observable<any> {
        return this._httpClient.put(this._baseURL + rte, { data: data });
    }
    delete(rte): Observable<any> {
        return this._httpClient.delete(this._baseURL + rte);
    }

    /*** Specializations ***/
    getSpecializationList(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'hospital/specialization/list');
    }
    getSpecialization(tnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'hospital/tenants/' + tnt_id + '/specialization/master');
    }
    addSpecialization(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/specialization/master/add', { data: data });
    }
    deleteSpecialization(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/specialization/master/delete', { data: data });
    }

    /*** Designations ***/
    getDesignationsList(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/designations/list');
    }
    getDesignation(tnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/designations/master');
    }
    addDesignation(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/designations/master/add', { data: data });
    }
    deleteDesignation(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/designations/master/delete', { data: data });
    }

    /*** Departments ***/
    getDepartmentList(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/departments/list');
    }
    getDepartment(tnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/departments/master');
    }
    addDepartment(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/departments/master/add', { data: data });
    }
    deleteDepartment(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/departments/master/delete', { data: data });
    }

    // Facility 

    getFacilityLst() {
        return this._httpClient.get(this._baseURL + 'hospital/facility/list');
    }

    getFacilityMater() {
        return this._httpClient.get(this._baseURL + 'hospital/facility/master');
    }

    // postFacility(data): Observable<any> {
    //     return this._httpClient.post(this._baseURL + 'hospital/facility/master', { data: data });
    // }

    updateFacility(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/facility/master/' + id, { data: data });
    }

    // deleteFacility(id): Observable<any> {
    //     return this._httpClient.delete(this._baseURL + 'hospital/facility/master/' + id);
    // }

    // Facility Catgeory

    getFacilityCategory() {
        return this._httpClient.get(this._baseURL + 'hospital/facility-category/list');
    }

    // Patient Groups

    getPtntGrpList() {
        return this._httpClient.get(this._baseURL + 'hospital/patient-group/master');
    }

    postPtntGrp(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/patient-group/master', { data: data });
    }

    updatePtntGrp(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/patient-group/master/' + id, { data: data });
    }

    deletePtntGrp(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'hospital/patient-group/master/' + id);
    }


    // Doctors

    getDoctorsLst() {
        return this._httpClient.get(this._baseURL + 'hospital/doctors/list');
    }

    getDoctorsMater() {
        return this._httpClient.get(this._baseURL + 'hospital/doctors/master');
    }

    postDoctors(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/doctors/master', { data: data });
    }

    updateDoctors(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/doctors/master/' + id, { data: data });
    }

    deleteDoctors(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'hospital/doctors/master/' + id);
    }

    // Gender

    getGndrLst() {
        return this._httpClient.get(this._baseURL + 'auth/gender/list');
    }

    // getbuldngslist
    getBldngsList() {
        return this._httpClient.get(this._baseURL + 'hospital/buildings/list');
    }

    addNewBuilding(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/buildings/addnew', { data: data });
    }


    addNewFloor(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/buildings/addfloor', { data: data });
    }

    addRoom(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/buildings/floors/addroom', { data: data });
    }


    getroomCtgryLst() {
        return this._httpClient.get(this._baseURL + 'hospital/buildings/rooms/ctgry');
    }

    getroomTypeLst() {
        return this._httpClient.get(this._baseURL + 'hospital/buildings/rooms/type');
    }

    deleteBuildng(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'hospital/buildings/list/' + id);
    }

    deleteBuildngFloor(id)
        : Observable<any> {
        return this._httpClient.delete(this._baseURL + 'hospital/delfloor/' + id);
    }

    deleteBuildngRoom(id)
        : Observable<any> {
        return this._httpClient.delete(this._baseURL + 'hospital/buildings/delroom/' + id);
    }


    updateBuilding(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/buildings/list/' + id, { data: data });
    }

    updateFloor(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/buildings/updtefloors/' + id, { data: data });
    }

    updteRooms(id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + 'hospital/buildings/updteRooms/' + id, { data: data });
    }

    getDcmnts(id, hndlr_nm) {
        return this._httpClient.get(this._baseURL + `entity/documents/${id}/${hndlr_nm}`);
    };
    getAddress(id, hndlr_nm) {
        return this._httpClient.get(this._baseURL + `entity/address/${id}/${hndlr_nm}`);
    }

    getContacts(id, hndlr_nm) {
        return this._httpClient.get(this._baseURL + `entity/contacts/${id}/${hndlr_nm}`);
    }
    get_note_hndlr(id, hndlr_nm) {
        return this._httpClient.get(this._baseURL + `entity/noteHndlr/${id}/${hndlr_nm}`);
    }


    openSnackBar(msg, cls) {
        this._snackBar.open(msg, '', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['mat-toolbar', cls]
        });
    }
    getHolidays(id, hndlr_nm) {
        return this._httpClient.get(this._baseURL + `entity/holidays/${id}/${hndlr_nm}`);
    }

    addNewReferalDoctor(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'hospital/referal/doctor', { data: data });
    }
    updateReferalDoctor(rfrl_dctr_id, data): Observable<any> {
        return this._httpClient.put(this._baseURL + `hospital/referal/doctor/${rfrl_dctr_id}`, { data: data });
    }
    deleteReferalDoctor(rfrl_dctr_id): Observable<any> {
        return this._httpClient.delete(this._baseURL + `hospital/referal/doctor/${rfrl_dctr_id}`);
    }

    /*** Countries ***/
    getCountriesList(tnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/countries/list');
    }
    getCountries(tnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/countries/master');
    }
    addCountries(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/countries/master/add', { data: data });
    }
    deleteCountries(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/countries/master/delete', { data: data });
    }

    /*** States ***/
    getStatesList(tnt_id, cntry_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/countries/' + cntry_id + '/states/list');
    }
    getStates(tnt_id, cntry_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/countries/' + cntry_id + '/states/master');
    }
    addStates(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/states/master/add', { data: data });
    }
    deleteStates(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/states/master/delete', { data: data });
    }

    /*** Districts ***/
    getDistricts(tnt_id, ste_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'auth/tenants/' + tnt_id + '/states/' + ste_id + '/districts/master');
    }
    addDistricts(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/districts/master/add', { data: data });
    }
    deleteDistricts(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'auth/districts/master/delete', { data: data });
    }
    getStoreTypes() {
        return this._httpClient.get(this._baseURL + 'billing/store-types');
    }
    getStores(fcltyId) {
        return this._httpClient.get(this._baseURL + 'billing/stores/' + fcltyId);
    }
    addStore(data) {
        return this._httpClient.post(this._baseURL + 'billing/store', { data: data });
    }
    updteStore(data) {
        return this._httpClient.put(this._baseURL + 'billing/store/' + data.stre_id, { data: data });
    }
    deleteStore(id) {
        return this._httpClient.delete(this._baseURL + 'billing/store/' + id);
    }

    getProductTypes() {
        return this._httpClient.get(this._baseURL + 'billing/product/types/list');
    }

    getProductList(selectedStore) {
        return this._httpClient.get(this._baseURL + 'billing/product/store-type/' + selectedStore + '/details');
    }
    getStoreTypeDetails(selectedStore) {
        return this._httpClient.get(this._baseURL + 'billing/product/store-type/' + selectedStore + '/product/list');
    }

    getProductGroups() {
        return this._httpClient.get(this._baseURL + 'billing/product/groups/list');
    }

    getProductStoreTypes() {
        return this._httpClient.get(this._baseURL + 'billing/product/store-types/list');
    }
    getProductIdentifiers() {
        return this._httpClient.get(this._baseURL + 'billing/product/identifiers/list');
    }
    getProductCategories() {
        return this._httpClient.get(this._baseURL + 'billing/product/categories/list');
    }
    getProductStorageClasses() {
        return this._httpClient.get(this._baseURL + 'billing/product/storage-classes/list');
    }
    getProductDetails(productID) {
        return this._httpClient.get(this._baseURL + 'billing/product/' + productID + '/details');
    }
    addProduct(data) {
        return this._httpClient.post(this._baseURL + 'billing/product/master', { data: data });
    }
    updateProduct(data) {
        return this._httpClient.put(this._baseURL + 'billing/product/master', { data: data });
    }
    showDailogeBox(data, width, clbk) {
        const dialogRef = this._matDialog.open(CustomDialougeBox, {
            disableClose: true,
            width: width,
            data: data
        });
        dialogRef.afterClosed().subscribe(result => {
            clbk(result);
        });
    }

    /********* Appointment Management ****/
    getServicesList(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'billing/appointment-management/services');
    }

    SetupLst = []
    // getsetupdata(callback): void {

    //     const rte = `cpay/web/setup/profiles`
    //     // if(this.SetupLst.length==0){
    //     this.apiSrv.get(rte).subscribe(res => {

    //         console.log(res);

    //         // tslint:disable-next-line:prefer-for-of
    //         for (let i = 0; i < res['data'].length; i++) {
    //             // tslint:disable-next-line:no-string-literal
    //             res['data'][i]['grp_nm'] = res['data'][i].stp_grp_nm;

    //             // tslint:disable-next-line:prefer-for-of
    //             for (let j = 0; j < res['data'][i].opts.length; j++) {
    //                 // tslint:disable-next-line:no-string-literal
    //                 res['data'][i].opts[j]['opt_nm'] = res['data'][i].opts[j].stp_opt_nm;
    //             }
    //         }

    //         // tslint:disable-next-line:no-string-literal
    //         this.SetupLst = res['data'];
    //         callback(false, this.SetupLst)
    //         // console.log(this.setup);
    //     });
    //     // }else{
    //     //   callback(false,this.SetupLst)
    //     // }

    // }

    getsetupdata() {
        return this._httpClient.get(this._baseURL + 'cpay/web/setup/profiles');
    }
}
